import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49094669"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container my-4 py-5 alegra-panel app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarFile = _resolveComponent("NavbarFile")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterFile = _resolveComponent("FooterFile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarFile),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_FooterFile)
  ], 64))
}